import { useInputControl, type FieldMetadata } from '@conform-to/react'
import { z } from 'zod'

import { IconHuman } from '~/components'
import { SimplifiedSelect } from '~/components/ui/input/select/shadcn-select'

export const numberOfUsersMultiSelectFormSchema = z.object({
  minPeople: z.coerce.number().int().min(1).optional(),
})

export const partialNumberOfUsersMultiSelectFormSchema =
  numberOfUsersMultiSelectFormSchema.partial()

type NumberOfUsersType = z.infer<
  typeof numberOfUsersMultiSelectFormSchema
>['minPeople']

type Option = {
  value: string
  label: string
}

const options: Option[] = [
  { value: '1', label: '1名以上' },
  { value: '2', label: '2名以上' },
  { value: '3', label: '3名以上' },
  { value: '4', label: '4名以上' },
  { value: '5', label: '5名以上' },
  { value: '6', label: '6名以上' },
  { value: '7', label: '7名以上' },
  { value: '8', label: '8名以上' },
  { value: '9', label: '9名以上' },
  { value: '10', label: '10名以上' },
  { value: '20', label: '20名以上' },
  { value: '30', label: '30名以上' },
]

export const useNumberOfUsersForm = (
  meta: FieldMetadata<NumberOfUsersType>,
  changeWatchedMinPeople?: (minPeople: string) => void,
) => {
  const control = useInputControl({
    ...meta,
    initialValue: meta.initialValue ?? '',
  })

  const onChange = (value: string) => {
    changeWatchedMinPeople?.(value)
    control.change(value)
  }

  return { value: control.value || '', onChange, name: meta.name }
}

type Props = {
  ariaLabel?: string
  value: string
  onChange: (value: string) => void
  name: string
}

export const NumberOfUsersMultiSelectForm = ({
  name,
  value,
  onChange,
  ariaLabel,
}: Props) => {
  return (
    <SimplifiedSelect
      aria-label={ariaLabel}
      isClearable
      name={name}
      onValueChange={onChange}
      options={options}
      placeholder="人数を選択"
      placeholderIcon={<IconHuman />}
      value={value}
    />
  )
}
